<div class="re-flex re-flex-col re-pt-60 re-items-center re-content-center">
  <div class="re-mb-30">
    <svg-icon class="icon" src="assets/icons/care_75x75.svg"></svg-icon>
  </div>

  <h4 class="re-text-center re-mb-45">{{ 'satisfactionPoll.success' | translate }}</h4>
</div>

